import guatemalaBoat from '../assets/guatemalaBoat.jpeg'
import guatemalaBuilding from '../assets/guatemalaBuilding.jpeg'
import guatemalaDock from '../assets/guatemalaDock.jpeg'
import guatemalaHike from '../assets/guatemalaHike.jpeg'
import guatemalaSanJuan from '../assets/guatemalaSanJuan.jpeg'
import brazilChurch from '../assets/brazilChurch.jpeg'
import brazilLavagem from '../assets/brazilLavagemDuBonfim.jpeg'
import brazilPelorinho from '../assets/brazilPelorinho.jpeg'
import brazilView from '../assets/brazilRioView.jpeg'
import brazilAtNight from '../assets/brazilRioAtNight.jpeg'
import brazilSalvadorView from '../assets/brazilSalvadorView.jpeg'
import irelandAntiques from '../assets/irelandAntiques.jpeg'
import irelandGlen from '../assets/irelandGlen.jpeg'
import irelandBlueHouse from '../assets/irelandBlueHouse.jpeg'
import irelandRoad from '../assets/irelandRoad.jpeg'
import irelandLibrary from '../assets/irelandLibrary.jpeg'
import irelandSheep from '../assets/irelandSheep.jpeg'
import londonBigBen from '../assets/londonBigBen.jpeg'
import londonEye from '../assets/londonEye.jpeg'
import londonRiver from '../assets/londonRiver.jpeg'
import londonTelephoneBooth from '../assets/londonTelephoneBooth.jpeg'
import londonSwan from '../assets/londonSwan.jpeg'
import barcelonaAlley from '../assets/barcelonaAlley.jpeg'
import barcelonaBeach from '../assets/barcelonaBeach.jpeg'
import barcelonaCandy from '../assets/barcelonaCandy.jpeg'
import barcelonaFlamenco from '../assets/barcelonaFlamenco.jpeg'
import barcelonaFountain from '../assets/barcelonaFountain.jpeg'
import barcelonaSteps from '../assets/barcelonaSteps.jpeg'
import greeceMountOlympus from '../assets/greeceMountOlympus.jpeg'
import greecePeninsula from '../assets/greecePeninsula.jpeg'
import greeceTempleOfPoseidon from '../assets/greeceTempleOfPoseidon.jpeg'
import greeceMetsovo from '../assets/greeceMetsovo.jpeg'
import greeceFortress from '../assets/greeceFortress.jpeg'
import greeceLycabettus from '../assets/greeceLycabettus.jpeg'
import italyStatue from '../assets/italyStatue.jpeg'
import italyVaticanMuseum from '../assets/italyVaticanMuseum.jpeg'
import italyPasta from '../assets/italyPasta.jpeg'
import italyRomanForum from '../assets/italyRomanForum.jpeg'
import italyColiseum from '../assets/italyColiseum.jpeg'
import newZealandDogstickLibrary from '../assets/newZealandDogstickLibrary.jpeg'
import newZealandHike from '../assets/newZealandHike.jpeg'
import newZealandLake from '../assets/newZealandLake.jpeg'
import newZealandMountains from '../assets/newZealandMountains.jpeg'
import newZealandRestaurant from '../assets/newZealandRestaurant.jpeg'
import newZealandWanakaTree from '../assets/newZealandWanakaTree.jpeg'
import germanyBuilding from '../assets/germanyBuilding.jpeg'
import germanyFriends from '../assets/germanyFriends.jpeg'
import germanyStreet from '../assets/germanyStreet.jpeg'
import germanyCastle from '../assets/germanyCastle.jpeg'
import germanyView from '../assets/germanyView.jpeg'
import germanyTrainStation from '../assets/germanyTrainStation.jpeg'
import baliCliff from '../assets/baliCliff.jpeg'
import baliMonkeys from '../assets/baliMonkeys.jpeg'
import baliRicePaddies from '../assets/baliRicePaddies.jpeg'
import baliShore from '../assets/baliShore.jpeg'
import baliSunset from '../assets/baliSunset.jpeg'
import baliTerrace from '../assets/baliTerrace.jpeg'

const travels = [
  { id: 1, title: "Greece", top: "35%", left: "51%", images: [greeceMountOlympus, greecePeninsula, greeceTempleOfPoseidon, greeceMetsovo, greeceFortress, greeceLycabettus ] },
  { id: 2, title: "Italy", top: "34%", left: "49.5%", images: [italyStatue, italyVaticanMuseum, italyPasta, italyRomanForum, italyColiseum] },
  { id: 3, title: "London, UK", top: "25%", left: "45%", images: [londonBigBen, londonEye, londonRiver, londonTelephoneBooth, londonSwan] },
  { id: 4, title: "Ireland", top: "26%", left: "43%", images: [irelandAntiques, irelandGlen, irelandBlueHouse, irelandRoad, irelandLibrary, irelandSheep] },
  { id: 5, title: "New Zealand", top: "85%", left: "93%", images: [newZealandWanakaTree, newZealandRestaurant, newZealandMountains, newZealandDogstickLibrary, newZealandLake, newZealandHike] },
  { id: 6, title: "Guatemala", top: "48%", left: "16%", images: [guatemalaBoat, guatemalaDock, guatemalaHike, guatemalaSanJuan, guatemalaBuilding] },
  { id: 7, title: "Brazil", top: "70%", left: "30%", images: [brazilChurch, brazilLavagem, brazilPelorinho, brazilView, brazilAtNight, brazilSalvadorView] },
  { id: 8, title: "Germany", top: "28%", left: "48%", images: [germanyCastle, germanyStreet, germanyFriends, germanyTrainStation, germanyBuilding, germanyView, ] },
  { id: 9, title: "Spain", top: "35%", left: "44%", images: [barcelonaAlley, barcelonaCandy, barcelonaSteps, barcelonaBeach, barcelonaFountain, barcelonaFlamenco] },
  { id: 10, title: "Bali", top: "64%", left: "78%", images: [baliCliff, baliRicePaddies, baliMonkeys, baliSunset, baliShore, baliTerrace] },
];

export default travels;
